import noop from '../utils/noop'
import PropTypes from 'prop-types'
import rangy from 'rangy'
import React, { Component } from 'react'
import { getRangeAt } from '../utils/range'
import TranscriptView from './TranscriptView'

export default class TextSelection extends Component {
  static propTypes = {
    endTime: PropTypes.number.isRequired,
    onSelect: PropTypes.func.isRequired,
    selectionClassName: PropTypes.string,
    selectionStyle: PropTypes.object,
    snapToWords: PropTypes.bool.isRequired,
    startTime: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    timestamps: PropTypes.array
  }

  static defaultProps = {
    endTime: 0,
    onSelect: noop,
    snapToWords: false,
    startTime: 0,
    text: ''
  }

  componentDidMount() {
    rangy.init()
  }

  removeSelection() {
    const sel = window.getSelection ? window.getSelection() : document.selection
    if (sel) {
      if (sel.removeAllRanges) {
        sel.removeAllRanges()
      } else if (sel.empty) {
        sel.empty()
      }
    }
  }

  handleMouseDown = () => {
    const { startTime, endTime, onSelect } = this.props

    if (startTime === endTime) {
      return
    }

    getRangeAt(0).collapse()

    onSelect({ collapsed: true })
  }

  handleMouseUp = () => {
    const { onSelect } = this.props
    const range = getRangeAt(0)

    const startElement = range.startContainer.parentElement
    const endElement = range.endContainer.parentElement

    if (!this.isChild(startElement) || !this.isChild(endElement)) {
      return
    }

    onSelect({
      collapsed: range.collapsed,
      startElement,
      endElement
    })

    this.removeSelection()
  }

  isChild(element) {
    const parent = element.parentNode

    if (!parent) {
      return false
    }

    if (parent === document.getElementById('transcript-view-container')) {
      return true
    }

    return this.isChild(parent)
  }

  render() {
    const {
      endTime,
      selectionClassName,
      startTime,
      text,
      timestamps
    } = this.props

    return (
      <div id="transcript-view-container">
        <TranscriptView
          text={text}
          timestamps={timestamps}
          selectionClassName={selectionClassName}
          selectionStartTime={startTime}
          selectionEndTime={endTime}
          componentClassName={
            'transcript-viewer transcript-viewer-no-max-height'
          }
          onMouseUp={this.handleMouseUp}
          onMouseDown={this.handleMouseDown}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/TextSelection.js